import * as React from "react";
import { useNewBrandStyle } from "../hooks/useNewBrandStyle";

interface ArrowProps {
  direction: "left" | "right";
}

const assetPrefix = process.env.ASSET_PREFIX || "";

export default function Arrow(props: ArrowProps) {
  const isNewBrandEnabled = useNewBrandStyle();

  const arrowIconPath = isNewBrandEnabled
    ? `new-brand/chevron-${props.direction}.svg`
    : `arrow-pointing-${props.direction}.svg`;
  return (
    <img src={`${assetPrefix}/static/${arrowIconPath}`} alt={props.direction} />
  );
}
